// extracted by mini-css-extract-plugin
export var chatHtmlText = "_nt-2";
export var chatLink = "_nt-0";
export var chatText = "_nt-1";